<script setup>
import {onMounted} from 'vue'
import {Auth, go} from '@/paks/vu-app'

onMounted(async () => {
    await Auth.logout({redirect: true})
    go({name: 'login'})
})
</script>

<template>
    <div />
</template>
